<p-table stripedRows #dtItems
    [value]="items"
    dataKey="id"
    editMode="row"
    [(selection)]="selected"
    [style]="{ width: '100%', 'min-width': '130em' }"
    scrollHeight="flex"
    [scrollable]="true"
    selectionMode="single"
    (onRowSelect)="this.SelectItem.next($event.data)"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="numCols" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
        <tr>
            <td [attr.colspan]="numCols" style="text-align: center">
                <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header let-item>
        <tr>
            <!-- Edit -->
            <th class="edit-cell"></th>
            <!-- status-->
            <th class="status-cell">
                <i
                    class="pi pi-exclamation-circle"
                    title="Status"
                ></i>
            </th>
            <!-- Selection -->
            <!-- <th style="width: 3em; text-align: center" >
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
    </th> -->

            <!-- AddressType -->
            <th pSortableColumn="AddressType">
                Type
                <p-sortIcon
                    field="AddressType"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter field="AddressType" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                            [virtualScroll]="true"
                            itemSize="32"
                            defaultLabel="Filter"
                            maxSelectedLabels="1"
                            appendTo="body"
                            [options]="addressTypes"
                            [filter]="true"
                            styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"
                        ></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- AddressName -->
            <th pSortableColumn="AddressName">
                Name
                <p-sortIcon
                    field="AddressName"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="AddressName" display="menu" class="ml-auto" />
            </th>
            <!-- Addr1 -->
            <th pSortableColumn="Addr1">
                Line 1
                <p-sortIcon
                    field="Addr1"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="Addr1" display="menu" class="ml-auto" />
            </th>
            <!-- Addr2 -->
            <th pSortableColumn="Addr2">
                Line 2
                <p-sortIcon
                    field="Addr2"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="Addr2" display="menu" class="ml-auto" />
            </th>
            <!-- Addr3 -->
            <th pSortableColumn="Addr3">
                Line 3
                <p-sortIcon
                    field="Addr3"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="Addr3" display="menu" class="ml-auto" />
            </th>
            <!-- Addr4 -->
            <th pSortableColumn="Addr4">
                Line 4
                <p-sortIcon
                    field="Addr4"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="Addr4" display="menu" class="ml-auto" />
            </th>
            <!-- City -->
            <th pSortableColumn="City">
                City
                <p-sortIcon
                    field="City"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="City" display="menu" class="ml-auto" />
            </th>
            <!-- State -->
            <th pSortableColumn="State">
                State
                <p-sortIcon
                    field="State"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter field="State" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                            [virtualScroll]="true"
                            itemSize="32"
                            defaultLabel="Filter"
                            maxSelectedLabels="1"
                            appendTo="body"
                            [options]="states"
                            [filter]="true"
                            styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"
                        ></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- PostalCode -->
            <th pSortableColumn="PostalCode">
                Zip
                <p-sortIcon
                    field="PostalCode"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="PostalCode" display="menu" class="ml-auto" />
            </th>
            <!-- Contact -->
            <th pSortableColumn="Contact">
                Contact
                <p-sortIcon
                    field="Contact"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="Contact" display="menu" class="ml-auto" />
            </th>
            <!-- AltContact -->
            <th pSortableColumn="AltContact">
                Alternate Contact
                <p-sortIcon
                    field="AltContact"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="AltContact" display="menu" class="ml-auto" />
            </th>
            <!-- delete -->
            <th class="delete-cell"></th>
        </tr>
    </ng-template>
    <ng-template
        #body
        let-item
        let-edit="editing"
        let-ri="rowIndex"
        let-rowData
    >
        <tr
            [pSelectableRow]="item"
            [pEditableRow]="item"
            data-id="row-{{ item.id }}"
            [ngClass]="{
                'ui-editing-row': edit && editing?.id === rowData?.id
            }"
        >
            <!-- Edit -->
            <td class="edit-cell">
                <button
                    *ngIf="item?.id === -1 && !edit"
                    pButton
                    type="button"
                    icon="pi pi-plus"
                    severity="success"
                    text
                    rounded
                    (click)="addAddressReplaySubject.next(true)"
                ></button>
                <button
                    *ngIf="
                        !edit &&
                        (!editing?.id || editing?.id === item?.id) &&
                        item.id !== -1
                    "
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    text
                    rounded
                    (click)="onEditItem(item)"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    type="button"
                    pSaveEditableRow
                    icon="pi pi-check"
                    severity="success"
                    text
                    rounded
                    (click)="onRowEditSave(item)"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    type="button"
                    pCancelEditableRow
                    icon="pi pi-times"
                    severity="danger"
                    text
                    rounded
                    (click)="onRowEditCancel(item)"
                ></button>
            </td>
            <!-- Status-->
            <td class="status-cell">
                <div (click)="onStatusClick(item)" class="status-cell">
                    <ef-status-icon
                        [status]="item?.Status?.StatusCode"
                        [message]="item?.Status?.Message"
                    ></ef-status-icon>
                </div>
            </td>
            <!-- Selection -->
            <!-- <td
                        style="width: 3em; text-align: center"

                    >
                        <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                    </td> -->

            <!-- AddressType -->
            <td class="disabled">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <p-select
                            [options]="addressTypes"
                            [filter]="true"
                            appendTo="body"
                            [autoDisplayFirst]="false"
                            placeholder="Type"
                            [(ngModel)]="item.AddressType"
                        >
                        </p-select>
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{
                            (
                                addressTypes
                                | itemlookup: 'value':item?.AddressType
                            )?.label
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                            (
                                addressTypes
                                | itemlookup: 'value':item?.AddressType
                            )?.label
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- AddressName -->
            <td class="disabled">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input pInputText [(ngModel)]="item.AddressName" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item.AddressName }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item.AddressName }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Addr1 -->
            <td [attr.title]="item.Addr1">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input pInputText [(ngModel)]="item.Addr1" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item.Addr1 }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item.Addr1 }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Addr2 -->
            <td [attr.title]="item.Addr2">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input pInputText [(ngModel)]="item.Addr2" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item.Addr2 }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item.Addr2 }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Addr3 -->
            <td [attr.title]="item.Addr3">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input pInputText [(ngModel)]="item.Addr3" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item.Addr3 }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item.Addr3 }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Addr4 -->
            <td [attr.title]="item.Addr4">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input pInputText [(ngModel)]="item.Addr4" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item.Addr4 }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item.Addr4 }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- City -->
            <td [attr.title]="item.City">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input pInputText [(ngModel)]="item.City" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item.City }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item.City }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- State -->
            <td [attr.title]="item.State">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <p-select
                            [options]="states"
                            [filter]="true"
                            appendTo="body"
                            [autoDisplayFirst]="false"
                            placeholder="Type"
                            [(ngModel)]="item.State"
                        >
                        </p-select>
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ (states | itemlookup: 'value':item?.State)?.label ?? item?.State }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ (states | itemlookup: 'value':item?.State)?.label ?? item?.State }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- PostalCode -->
            <td [attr.title]="item.PostalCode">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input pInputText [(ngModel)]="item.PostalCode" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item.PostalCode }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item.PostalCode }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Contact -->
            <td [attr.title]="item.Contact">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input pInputText [(ngModel)]="item.Contact" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item.Contact }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item.Contact }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- AltContact -->
            <td [attr.title]="item.AltContact">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input pInputText [(ngModel)]="item.AltContact" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item.AltContact }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item.AltContact }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <td class="delete-cell">
                <button
                    pButton
                    type="button"
                    class="btn btn-link"
                    (click)="DeleteItem.next(item)"
                    icon="pi pi-trash"
                    severity="danger"
                    text
                    rounded
                ></button>
            </td>
        </tr>
    </ng-template>
</p-table>
<ef-invoice-address-add
    [states]="states"
    [addressTypes]="addressTypes"
    [item]="editItemSubject.asObservable() | async"
    [addAddress]="addAddressReplaySubject.asObservable() | async"
    (Cancel)="onCancelAddress()"
    (Save)="onSaveAddress($event)"
></ef-invoice-address-add>
